import {HashRouter as Router, Routes, Route, Redirect} from 'react-router-dom'
import Navbar from './fluentcomponents/Navbar/Navbar'
import Home from './fluentcomponents/Home/Home'
import Footer from './fluentcomponents/Footer/Footer'
import DataSection from './components/Screens/DataSection/DataSection'
import ContentListScreen from './fluentcomponents/ContentListScreen/ContentListScreen'
import BlogScreen from './fluentcomponents/BlogScreen/BlogScreen'
// GET DATA HERE


const font = "IBM Plex Sans"
const App = ()=>{
  return (

        <Router>
            <Navbar font={font} />
            <Routes>
                    <Route exact path="/" element={<Home  font = {font} />} />
                    <Route path="/projects" element={<ContentListScreen font = {font}  type="project" filter={{type:"project"}}  title="Projects" cover={process.env.PUBLIC_URL+"/bg1.jpg"}/>} />
                    <Route path="/content" element={<ContentListScreen  font = {font} type="content"  filter={{type:"content"}} title="Content" cover={process.env.PUBLIC_URL+"/contentlistbg.webp"}/>} />
                    <Route path="/project/:id" element={<BlogScreen font = {font}  markdown="asd" cover={process.env.PUBLIC_URL+"/contentlistbg.webp"}/>}/>
                    <Route path="/content/:id" element={<BlogScreen  font = {font} markdown="assasasd" cover={process.env.PUBLIC_URL+"/contentlistbg.webp"}/>}/>
                    <Route path="/about" element={<BlogScreen  font = {font} about={true} markup="assasasd" cover={process.env.PUBLIC_URL+"/contentlistbg.webp"}/>}/>

                    <Route path="*"element={<Home />} />
            </Routes>
            <Footer font={font}/>
        </Router>
    )
}
export default App